import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { Filter } from '../../../types/Filter';
import { UserConfigurableModule } from '../../../types/User';

export const fetchCurrentUserFilters = async (page?: UserConfigurableModule) => {
  const response = await CustomAxios.get<Filter[]>(`/user-filters`, { params: { page } });
  const { data } = response;
  return data;
};

interface IUseGetCurrentUserFiltersArgs {
  page: UserConfigurableModule;
  enabled?: boolean;
}

export function useGetCurrentUserFilters({ page, enabled = true }: IUseGetCurrentUserFiltersArgs) {
  const query = useQuery({
    queryKey: [queryKeys.currentUserFilters, page],
    staleTime: 1000 * 60 * 60,
    queryFn: () => fetchCurrentUserFilters(page),
    enabled,
  });

  return query;
}
